export default {"src":"/planos/_next/static/media/equifax-user-check.193b14da.svg","height":21,"width":32,"blurWidth":0,"blurHeight":0};